export const getBaseApiUrl = ()=>{
    return "/api/"
}